export const RSVP_STYLES = {
  default: {
    typeName: 'Default',
    who: "Who's Coming?",
    yes: 'Yes',
    maybe: 'Maybe',
    no: 'No',
  },
  write_your_own: {
    typeName: 'Write Your Own',
    who: '',
    yes: '',
    maybe: '',
    no: '',
  },

  california: {
    typeName: 'California',
    who: "Who's Coming?",
    yes: 'Totally',
    maybe: 'Whatever',
    no: 'Bummer',
  },
  casual: {
    typeName: 'Casual',
    who: "Who's In?",
    yes: 'Absolutely',
    maybe: 'Hmmm',
    no: 'Unthinkable',
  },
  fashionista: {
    typeName: 'Fashionista',
    who: 'In or Out?',
    yes: 'In',
    maybe: 'Having a Makeover',
    no: 'Out',
  },
  food: {
    typeName: 'Food',
    who: 'Who’s hungry?',
    yes: 'Down to dig in!',
    maybe: 'Depends on the dish...',
    no: 'Sorry, I’m stuffed!',
  },
  football: {
    typeName: 'Football',
    who: "Who's Coming?",
    yes: 'Touchdown',
    maybe: '4th & 1',
    no: 'Fumble',
  },
  formal: {
    typeName: 'Formal',
    who: "Who's Attending?",
    yes: 'With Pleasure',
    maybe: 'Tentatively',
    no: 'Regrets',
  },
  happy_hour: {
    typeName: 'Happy Hour',
    who: 'Up for Drinks?',
    yes: 'Let It Flow',
    maybe: 'Cutting Back',
    no: 'On the Wagon',
  },
  hoops: {
    typeName: 'Hoops',
    who: "Who's Playing?",
    yes: "Nothin' but Net",
    maybe: 'Hit the Rim',
    no: 'Airball',
  },
  jadore_le_french: {
    typeName: "J'adore Le French",
    who: 'On Fait La Fete?',
    yes: 'Mais, Oui!',
    maybe: 'Je Ne Sais Pas',
    no: 'Non',
  },
  moods: {
    typeName: 'Moods',
    who: 'Feelin’ it?',
    yes: 'Yasss',
    maybe: 'Meh',
    no: 'Nah',
  },
  natural: {
    typeName: 'Natural',
    who: "Who's In?",
    yes: "I'll Be There",
    maybe: "Eh... We'll See",
    no: 'Not Gonna Make It',
  },
  pawty: {
    typeName: 'Pawty',
    who: 'Is it pawty time?',
    yes: 'Pawsitively',
    maybe: 'Pawsibly?',
    no: 'Pawty Poopers',
  },

  road_trip: {
    typeName: 'Road Trip',
    who: "Who's Rallying?",
    yes: 'Full Throttle',
    maybe: 'Stalled',
    no: 'Out of Gas',
  },
  shakespeare: {
    typeName: 'Shakespeare',
    who: 'To Be or Not to Be?',
    yes: 'To Be',
    maybe: 'That Is the Question',
    no: 'Not to Be',
  },
  smiley: {
    typeName: 'Smiley',
    who: '?',
    yes: '\ud83d\ude03',
    maybe: '\ud83d\ude11',
    no: '\ud83d\ude1f',
  },
  spanish: {
    typeName: 'Spanish',
    who: '¿Quien asistirá?',
    yes: 'Claro que sí',
    maybe: 'Tal vez',
    no: 'Que lastima',
  },
  varsity: {
    typeName: 'Varsity',
    who: 'The Team',
    yes: 'Starters',
    maybe: 'Benched',
    no: 'Cut',
  },
  vegas_baby: {
    typeName: 'Vegas, Baby!',
    who: 'Ante Up',
    yes: 'All In',
    maybe: 'Split',
    no: 'Bust',
  },
};
